import React from "react";
import { getImageUrl } from "../api";
import { X } from "lucide-react";

export default function NoticiaDetalle({ noticia, onClose }) {
  const [isVertical, setIsVertical] = React.useState(false);

  // ✨ 3. Usar la nueva función centralizada y simple
  const imagenUrl = getImageUrl(noticia?.imagen_url);

  // log para comprobar que url se genera correctamente

  React.useEffect(() => {
    if (imagenUrl) {
      const img = new Image();
      img.src = imagenUrl;
      img.onload = () => {
        setIsVertical(img.height > img.width);
      };
      img.onerror = () => {
        console.error(`❌ Error al cargar la imagen del detalle: ${imagenUrl}`);
      };
    }
  }, [imagenUrl]);

  if (!noticia) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-3xl overflow-y-auto max-h-[90vh] relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-3 right-3 text-gray-500 bg-white bg-opacity-70 hover:bg-opacity-100 hover:text-red-600 p-2 rounded-full transition-all duration-200 z-10"
          onClick={onClose}
          aria-label="Cerrar"
        >
          CERRAR
        </button>

        <div className="relative">
          <img
            src={imagenUrl || '/LogoPiedecuestana.png'}
            alt={noticia.titulo || "Imagen de la noticia"}
            className={`w-full max-h-[60vh] rounded-t-lg ${
              isVertical ? "object-contain" : "object-cover"
            }`}
            onError={(e) => {
              e.target.src = '/LogoPiedecuestana.png';
              e.target.classList.add('object-contain');
            }}
          />
        </div>

        <div className="p-6">
          <h2 className="text-2xl font-bold mb-2 text-gray-800">{noticia.titulo}</h2>
          {noticia.fecha_publicacion && (
            <p className="text-sm text-gray-500 mb-4">
              📅 Publicado:{" "}
              {new Date(noticia.fecha_publicacion).toLocaleDateString("es-ES", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
          )}
          <div className="text-gray-700 leading-relaxed whitespace-pre-line bg-gray-50 p-4 rounded-lg">
            {noticia.contenido}
          </div>
          
          {process.env.NODE_ENV === 'development' && (
            <div className="mt-4 p-3 bg-blue-50 rounded text-xs">
              <strong>Debug Info:</strong><br/>
              URL original: {noticia?.imagen_url}<br/>
              URL final: {imagenUrl}<br/>
              Vertical: {isVertical ? 'Sí' : 'No'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}